import { authInterceptor } from "@/api2/interceptors";
import { getEnvVars } from "@/lib/common/get-env-vars";
import axios, { AxiosError, AxiosRequestConfig } from "axios";

const { env } = getEnvVars();

export const AXIOS_INSTANCE = axios.create({
  baseURL: env.APP_API_URL + env.APP_REST_REF
});

AXIOS_INSTANCE.interceptors.request.use(async (config) => {
  if (config.url?.includes("refresh")) return config;

  const isLoginPage = globalThis.location.pathname === "/user/login";

  const controller = new AbortController();
  const token = isLoginPage ? null : await authInterceptor();

  if (!token && !isLoginPage) {
    controller.abort();
    globalThis.location.pathname = "/user/login";

    return config;
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return {
    ...config,
    signal: controller.signal
  };
});

export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<T> => {
  const source = axios.CancelToken.source();
  const promise = AXIOS_INSTANCE({
    ...config,
    ...options,
    cancelToken: source.token
  }).then(({ data }) => data);

  return promise;
};

export type ErrorType<Error> = AxiosError<Error>;

export type BodyType<BodyData> = BodyData;
